<template>
  <ThreeColumn>
    <template v-slot:splashes>
      <!--sponsors-->
      <v-row class="navlink sponsor-banner-bg pb-xs-3 py-2 d-print-none" align="center" no-gutters>
        <v-col cols="12" sm="8" md="7" lg="8" class="pl-4" > <!--py-xs-2 pt-lg-3-->
          <v-icon small color="white" class="mr-2 mb-1">mdi-charity</v-icon><span class="white--text align-center" v-html="$t('sponsors.banner_text')"></span>
        </v-col>
        <v-col cols="12" sm="4" md="5" lg="4" class=" py-2 px-4">
          <v-row no-gutters justify="end">
            <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined
              color="white"
              class="mr-2"
              min-width="160px"
              href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute" target="_blank">
              {{$t('btntxt.donate')}}
            </v-btn>

            <v-btn color="primary" to="/hklii2023" 
            min-width="160px"
            :block="$vuetify.breakpoint.smAndUp? false:true" >
              <span class="white--text">{{$t('sponsors.banner_btn')}}</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <!--hero-->
      <v-row class="hero-bg liiblack" no-gutters>
                
        <!--SPACER LEFT PANEL--><v-col cols="12" md="2" lg="2" :class="$vuetify.breakpoint.mdAndUp?'pt-8':'pt-4'"  class="hidden-sm-and-down"></v-col> 
        <!--content: name and logo-->
        <v-col cols="12" md="8" lg="7" class="pt-5 pb-4 pl-lg-12 pl-xl-16" :class="$vuetify.breakpoint.xs?'px-4':'px-6'" >
                  
          <!--logo-->
          <v-img
            alt="HKLII Logo"
            class="mb-5 logoimage"
            contain
            :src="require('../assets/hkliilogo_dark.svg')"
            min-width="70"
            max-width="170"
            :width="$vuetify.breakpoint.xs? '120px':'170px'" :height="$vuetify.breakpoint.xs?'62.71px':'88.84px'"
          />
                      
          <!--HKLII header text-->
          <h1 class="sitetitle white--text mb-3" :class="$vuetify.breakpoint.xs? 'sitetitle-xs':''">{{$t('home.fullname')}}</h1>
          <h2 class="siteslogan footergrey--text mb-5" :class="$vuetify.breakpoint.xs? 'siteslogan-xs':''">{{$t('home.subheading')}}</h2>

          <!--search boxes-->
          <v-row>
            <v-col cols="12" sm="8" >
              <v-card tile class="bannersearch pb-2 fill-height" >
                <!--Operators button-->
                <v-row no-gutters class="pl-1 mb-2">
                  <h4 class="subtitle-2 font-weight-light white--text">{{$t('btntxt.search')}}</h4>
                  <v-tooltip top color="liiblack lighten-1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="lightgrey" small class="ml-2" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                      </template>
                    <span v-html="$t('home.simple_desc')"></span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <v-btn dense small text color="white" 
                    height="22"
                    :to="{name:'operators'}" 
                    class="font-italic px-0">
                    {{$t('operators.t_operators')}}
                  </v-btn>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="12" sm="10">
                    <v-combobox
                      :items="items"
                      :loading="isLoading"
                      :search-input.sync="search"
                      :value="search"
                      :return-object="false"
                      background-color="white"
                      color="primary"
                      hide-no-data dense clearable filled solo outlined hide-details
                      append-icon=""
                      class="mb-0"
                      placeholder='e.g A v. B; "Wills Ordinance" AND gift*'
                      @change="isSelecting = false"
                      @update:list-index="(i) => {isSelecting = (i >= 0)}"
                      @keydown.enter="() => {if(!isSelecting){go_search()}}"
                      @update:search-input="isSelecting = false"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="2">
                      <v-btn block tile color="primary"  @click="go_search" height="40">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                  </v-col>
                </v-row>

              </v-card>
            </v-col>
                      
            <!--Advance Search button-->
            <v-col cols="12" sm="4" height="100vh" class="pl-sm-0">
              <v-card tile class="bannersearch pb-5" height="100%" :max-width="$vuetify.breakpoint.smAndUp?'350px':''">
                <v-row no-gutters class="pl-1 mb-2">
                  <h4 class="subtitle-2 font-weight-light white--text">{{$t('search.advs.advanced')}}</h4>
                  <v-tooltip top color="liiblack lighten-1">
                  <template v-slot:activator="{ on, attrs }">
                  <v-icon color="lightgrey" small class="ml-2" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                    </template>
                  <span>{{$t('home.advanced_desc')}}</span>
                </v-tooltip>
                </v-row>

                <v-row no-gutters>
                  <v-btn 
                    tile block
                    color="primary"  
                    height="40" 
                    :to="{name:'advanced-search'}"
                  >
                    {{$t('search.advs.advancedshort')}} <v-icon class="ml-4">mdi-text-search</v-icon>
                  </v-btn>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-col class="px-0 pb-0 mb-8 mb-sm-2">
            <v-btn large class="px-4 mr-4 mb-3" color="lsidebg" to="databases">{{$t('btntxt.all')}}{{$t('database.dbs')}}</v-btn>
            <v-btn large class="px-4 mr-4 mb-3" color="l_case" :to="{name:'databases', query:{'cat':'C'}}">{{$t('home.judgments')}}</v-btn>
            <v-btn large class="px-4 mr-4 mb-3" color="l_legis" :to="{name:'databases', query:{'cat':'L'}}">{{$t('home.legislation')}}</v-btn>
            <v-btn large class="px-4 mr-4 mb-3" color="l_other" :to="{name:'databases', query:{'cat':'O'}}">{{$t('database.others')}}</v-btn>
            <v-btn large class="px-4 mb-3" color="l_other" :to="{name:'other-db',params:{lang: pdlang , abbr:'pd'} }">{{$t('database.pd')}}</v-btn>
          </v-col>

          <!--Shortcuts-->
          <v-col class="px-0 pb-0" v-if="$vuetify.breakpoint.smAndUp" no-gutters id="home-shortcut">
            <v-divider role="presentation"></v-divider>
            <v-expansion-panels flat v-model="shortcutPanel">
              <v-expansion-panel class="liiblack">
                <v-expansion-panel-header class="liiblack liiblack--text text--lighten-5 py-0 px-1">
                   <v-tooltip color="liiblack lighten-1" max-width="300"
                    :top="$vuetify.breakpoint.mdAndDown" :right="$vuetify.breakpoint.lgAndUp"
                    :nudge-right="$vuetify.breakpoint.lgAndUp? 60 : 10" :nudge-bottom="$vuetify.breakpoint.lgAndUp? 10 : 0">
                     <template v-slot:activator="{ on, attrs }">
                       <span v-bind="attrs" v-on="on" class="wdgt-subtitle pt-1 mb-0"> {{ $t('btntxt.shortcut') }} </span> 
                     </template>
                     <v-row>
                      <v-col cols="1">
                        <v-icon color="white" small>mdi-pin</v-icon>
                      </v-col>
                       <v-col cols="11">
                        <span> {{$t('home.shortcut_hint')}}</span>
                      </v-col>
                     </v-row>
                   </v-tooltip>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0 mb-4">
                  <HomeShortcut />
                  <v-divider role="presentation"></v-divider>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

        </v-col> <!--close content: name and logo-->

        <!--SPACER RIGHT PANEL-->
        <v-col cols="12" md="12" lg="3" class="px-7 pt-6  hidden-md-and-down d-print-none">
          <v-alert dismissible icon="mdi-routes" text class="pr-5 py-3" color="white" @input="showTourAlert=false" v-if="showTourAlert" max-width="350">
            <span class="font-weight-light">{{$t('tour.welcomealert')}}</span><br>
            <a class="alert-link" @click="viewtour=true">{{$t('tour.tourlink')}}</a>
          </v-alert>
        </v-col><!--close SPACER RIGHT PANEL-->

      </v-row> 

      <!--Tools-->
      <v-row class="rsidebg  d-print-none" no-gutters >
        <!--SPACER LEFT PANEL-->
        <v-col cols="12" md="2" lg="2" :class="$vuetify.breakpoint.mdAndUp?'pt-8':'pt-4'"  class="hidden-sm-and-down"></v-col> <!-- close SPACER LEFT PANEL-->

        <!--tool cards-->
        <v-col cols="12" md="8" lg="7" class="pt-5 pb-6 pl-lg-12 pl-xl-16" :class="$vuetify.breakpoint.xs?'px-4':'px-6'">  
          <h1 class="text-h1 pt-1 mb-3 liiblack--text" >{{$t('liitools.title')}}</h1>
          <v-row class="pl-md-7">
            <v-col cols="12" md="4">
              <HomeTool 
              :addr="'http://wwwnew2.hklii.hk/predictor'" 
              :title="$i18n.t('liitools.predictor')" 
              :content="$i18n.t('liitools.predictor_desc')" 
              :thumbnail="'Predictor_thumb.png'" 
              :labels="[$i18n.t('liitools.tag_dt'),$i18n.t('liitools.tag_sentence')]"
              :gradientStyle="'to bottom, rgba(25,32,72,.6), rgba(255,255,255,.0)'"
              >
              <!--rgba(25,32,72,.6), rgba(100,115,201,.0)'-->
              </HomeTool>
            </v-col>
            <v-col cols="12" md="4">
              <HomeTool 
              :addr="'https://ai.hklii.hk/case-analytics/'" 
              :title="$i18n.t('liitools.sqe')" 
              :content="$i18n.t('liitools.sqe_desc')" 
              :thumbnail="'CA_thumb.png'" 
              :labels="[$i18n.t('liitools.tag_dt'),$i18n.t('liitools.tag_pi'), $i18n.t('liitools.tag_stats')]"
              :gradientStyle="'to bottom, rgba(93,47,47,.6), rgba(255,255,255,.0)'"
              >
              </HomeTool>
            </v-col>
            <v-col cols="12" md="4">
              <HomeTool 
              :addr="'https://ai.hklii.hk/case-summary/'" 
              :title="$i18n.t('liitools.summary')" 
              :content="$i18n.t('liitools.summary_desc')" 
              :thumbnail="'case_summary_thumb.png'" 
              :labels="[$i18n.t('liitools.tag_pi'), $i18n.t('liitools.tag_summary')]"
              :gradientStyle="'to bottom, rgba(101,113,171,.5), rgba(255,255,255,.0)'"
              ><!--to bottom, rgba(93,47,47,.6), rgba(193,43,46,.0)'-->
              </HomeTool>
            </v-col>
          </v-row>
        </v-col>
        <!--SPACER RIGHT PANEL--><v-col cols="12" md="12" lg="3" class="px-7 pt-6 hidden-sm-and-down"></v-col><!--close SPACER RIGHT PANEL-->
      </v-row>

      <!--news-->
      <v-row class="footergrey lighten-1" no-gutters >
            
        <!--SPACER LEFT PANEL-->
        <v-col cols="12" md="2" lg="2" :class="$vuetify.breakpoint.mdAndUp?'pt-8':'pt-4'"  class="hidden-sm-and-down"></v-col> <!-- close SPACER LEFT PANEL-->

        <!--news content-->
        <v-col cols="12" md="8" lg="7" class="pt-5 pb-6 pl-lg-12 pl-xl-16" :class="$vuetify.breakpoint.xs?'px-4':'px-6'">
          <h1 class="text-h1 pt-1 liiblack--text" >{{$t('home.announcements')}}</h1>
          <v-card flat color="transparent" max-width="850px" class="mt-6">
            <!--Buttons for xs only-->
            <v-row v-if="$vuetify.breakpoint.xs" no-gutters>
              <v-col>
                <v-item-group
                  v-model="window"
                  class="shrink text-center" mandatory
                >
                  <v-item
                    v-for="n in length" :key="n"
                    v-slot="{ active, toggle }"
                  >
                    <v-btn
                      :input-value="active"
                      active-class="news-active" class="mx-2" color="footergrey"
                      height="3px"
                      @click="toggle"
                    >
                    </v-btn>
                  </v-item>
                </v-item-group>
              </v-col>
            </v-row>

            <v-row>
              <!--Buttons Hide if xs-->
              <v-item-group
                v-model="window"
                mandatory class="shrink ml-2 mr-5 pt-1"
                v-if="!$vuetify.breakpoint.xs"
              >
                <v-item
                  v-for="n in length" :key="n"
                  v-slot="{ active, toggle }"
                >
                  <div>
                    <v-btn
                      :input-value="active"
                      icon color="navlink"
                      @click="toggle"
                    >
                      <v-icon>mdi-record</v-icon>
                    </v-btn>
                  </div>
                </v-item>
              </v-item-group>

              <!--Slides-->
              <v-col class="pt-md-0 ">
                <v-window
                  v-model="window"
                  vertical
                  class="news elevation-3"
                >

                  <!--Deployment of ITF deliverables-->                 
                  <NewsSlide :useShowMore=true date="11 Jul, 2023">
                    <template v-slot:titleText>
                      {{$t('home.news_4_title')}}
                    </template>
                    <template v-slot:introText> 
                      <i18n path="home.news_4_intro[0]" tag="p" class="mb-2"></i18n>
                      <i18n path="home.news_4_intro[1]" tag="p" class="mb-2">
                        <router-link :to="{name:'news'}" class="beta-tag">{{$t('btntxt.newfeature')}}</router-link>
                        <router-link :to="{name:'news'}">{{$t('btntxt.news')}}</router-link>
                      </i18n>
                      
                      <ul class="pb-2">
                        <li v-for="(item,idx) in $t('home.news_4_newfeature')" :key="idx">
                          <router-link :to="'/news#'+ $t('home.news_4_bookmarks')[idx]">
                            <span class="black--text">{{item}}</span>
                            <v-icon color="link" small class="ml-2 mb-1">mdi-book-open-variant</v-icon>
                          </router-link>
                        </li>
                      </ul>

                      <i18n path="home.news_4_intro[2]" tag="p" class="mb-0">
                        <a href="https://ai.hklii.hk/case-summary" target="_blank">{{$t('liitools.sqe')}}</a>
                      </i18n>
                    </template>
                    <template v-slot:expandedText>
                      <i18n path="home.news_4_content[0]" tag="p">
                        <router-link :to="{name:'feedback'}">{{$t('legal.pp_feedback')}}</router-link>
                      </i18n>
                      <i18n path="home.news_4_content[1]" tag="p"></i18n>
                      <p class="caption liiblack--text"><b>{{$t('home.signoff')}}</b></p>
                    </template>
                  </NewsSlide>

                  <!--HKLII Migration-->
                  <NewsSlide :useShowMore=false date="16 Jun, 2023">
                    <template v-slot:titleText>
                      {{$t('home.news_3_title')}}
                    </template>
                    <template v-slot:introText> 
                     <i18n path="home.news_3_content[0]" tag="p" class="mb-2">
                        <a href="https://www.hklii.hk">www.hklii.hk</a>
                      </i18n>
                      <i18n path="home.news_3_content[1]" tag="p" class="mb-2">
                        <a href="https://classic.hklii.hk" target="_blank">classic.hklii.hk</a>
                      </i18n>
                      <i18n path="home.news_3_content[2]" tag="p" class="mb-2">
                        <a href="/feedback">{{$t('home.feedbackpage')}}</a>
                      </i18n>
                    </template>
                  </NewsSlide>

                  <!--CLC parallel citation-->
                  <NewsSlide :useShowMore=false date="12 Apr, 2023">
                    <template v-slot:titleText>
                      {{$t('home.news_2_title')}}
                    </template>
                    <template v-slot:introText> 
                      <i18n path="home.news_2_content[0]" tag="p" class="mb-2"></i18n>
                      <i18n path="home.news_2_content[1]" tag="p" class="mb-2"></i18n>
                    </template>
                  </NewsSlide>

                  <!--Welcome to beta-->                 
                  <NewsSlide :useShowMore=true date="22 Apr, 2022">
                    <template v-slot:titleText>
                      {{$t('home.news_1_title')}}
                    </template>
                    <template v-slot:introText> 
                      <i18n path="home.news_1_intro" tag="p" class="mb-0">
                        <a @click.prevent="viewtour=true">{{$t('home.sitetour')}}</a>
                      </i18n>
                    </template>
                    <template v-slot:expandedText>
                      <ul class="pb-4">
                        <li v-for="(item,idx) in $t('home.news_1_newfeature')" :key="idx">{{item}}</li>
                      </ul>

                      <h6 class="text-h6 liiblack--text pb-1">{{$t('home.news_1_subhead[0]')}}</h6>
                      <i18n path="home.news_1_content[0]" tag="p">
                        <a @click.prevent="$emit('open-rating')">{{$t('home.ratingbox')}}</a>
                        <a href="/feedback">{{$t('home.feedbackfrom')}}</a>
                      </i18n>

                      <h6 class="text-h6 liiblack--text pb-1">{{$t('home.news_1_subhead[1]')}}</h6>
                      <i18n path="home.news_1_content[1]" tag="p">
                        <a href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute" target="_blank">{{$t('home.news_1_donation')}}</a>
                        <a href="/donors">{{$t('home.news_1_thankdonor')}}</a>
                      </i18n>
                      
                      <p class="caption liiblack--text"><b>{{$t('home.signoff')}}</b></p>
                    </template>
                  </NewsSlide>
                  
                </v-window>
              </v-col>
            </v-row>

          </v-card>
        </v-col>

        <!--SPACER RIGHT PANEL--><v-col cols="12" md="12" lg="3" class="px-7 pt-6 hidden-sm-and-down"></v-col><!--close SPACER RIGHT PANEL-->

      </v-row><!--close news-->

      <!--tour overlay-->
      <Tour :tourdialog="viewtour" @close-dialog="viewtour=false" @open-rate-dialog="$emit('open-rating')"></Tour>
    
    </template>

    <template v-slot:title>
      <v-row no-gutters>
        <v-col cols="12">
          <h1 class="text-h1 mb-0 liiblack--text">{{$t('home.news')}}</h1>
        </v-col>
      </v-row>
    </template>

    <template v-slot:leftPanel v-if="$vuetify.breakpoint.mdAndUp">
      <StatusWidget :statinfo="stat_wdgt" />
    </template>

    <template v-slot:mainPanel>
      <!--latest judgements-->
      <v-card flat>
        <!--case type drop-down-->
        <v-card-subtitle class="pt-2 pb-1 pl-4 lsidebg">
          <v-row no-gutters align="baseline">
            <span class="pr-3">{{$t('database.filter')}} </span>
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small outlined
                  color="link"
                  style="height: auto"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{court}}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(court, index) in courts"
                  :key="index"
                  @click="setCourt(court)"
                >
                  <v-list-item-title class="text-uppercase">{{ court }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-card-subtitle>

        <v-card-text class="px-0">
          <template>
            <v-data-table
              dense
              :headers="headers"
              :items="files"
              disable-pagination
              hide-default-footer
              calculate-widths
              class="tlatest dbtoc"
              :loading="loading"
              :class="{'dtdesktop': $vuetify.breakpoint.smAndUp}"
              :loading-text="$i18n.t('database.loading')"
              :no-data-text="$i18n.t('error.nodata_warn')"
              :no-results-text="$i18n.t('error.noresult_warn')"
              :header-props="{'sort-by-text':$i18n.t('database.sortby')}"
            >
              <template v-slot:item="{item}">
                <tr v-if="$vuetify.breakpoint.smAndUp" @click="(event)=>goFile(item, event)" ><!--desktop TOC-->
                  <td class="pr-1">
                    <router-link :to="{path: item.path}" class="routing" v-html="item.db_name"></router-link>
                  </td>
                  <td class="pr-1">
                    <router-link :to="{path: item.path}" class="routing" v-html="item.title"></router-link>
                  </td>
                    <td class="pr-1">
                    <router-link :to="{path: item.path}" class="routing" v-html="item.neutral"></router-link>
                  </td>
                    <td class="pr-1">
                    <router-link :to="{path: item.path}" class="routing" v-html="item.acts"></router-link>
                  </td>
                    <td class="dt-date pr-3">
                    <router-link :to="{path: item.path}" class="routing" v-html="item.date"></router-link>
                  </td>
                </tr>
                <tr v-else @click="(event)=>goFile(item,event)"> <!--mobile TOC-->
                  <td>
                    <router-link class="routing" :to="{path: item.path}">
                      <span class="mobiledt_subinfo mobiledt_label mr-2" v-html="item.neutral"></span>
                      <span class="mobiledt_subinfo mobiledt_darker" v-html="item.m_acts"></span><br>
                      <span class="mobiledt_subinfo" v-html="item.date"></span><br>
                      <span class="mobiledt_title" v-html="item.title"></span>
                    </router-link>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </template>

        </v-card-text>

      </v-card>
    </template>

    <template v-slot:rightPanel>
      <!--DONATE & SUPPORT US CARD-->
      <v-card flat class="rsidecard mb-4 mr-md-3 mr-lg-0 pb-3" max-width="400" min-width="250" >
        <div class="white--text navlink">
          <v-card-title class="my-auto px-5 py-3">
            <donate-icon color="white" class="mb-1 mr-2"></donate-icon>
            <h5 class="text-h5">{{$t('home.donatecard_title')}}</h5>
          </v-card-title>
        </div>
        <v-card-text class="px-5 pb-0">
          <i18n path="home.donatecard_content" tag="p">
            <a href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute" target="_blank">{{$t('home.news_1_donation')}}</a>
          </i18n>
        </v-card-text>
        <v-card-actions class="px-5">
          <v-btn block large target="_blank" color="navlink" class="white--text" href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute">
            {{$t('btntxt.donate')}}
          </v-btn>
        </v-card-actions>
      </v-card>

      <!--FALM CARD-->
      <v-card flat  class="rsidecard mb-4 mr-md-3 mr-lg-0  pb-3" max-width="400" min-width="250" >
        <v-card-title class="px-5">
          <h5 class="text-h5" >Free Access to Law Movement</h5>
        </v-card-title>
        <v-card-text class="px-5">
          <a href="http://www.falm.info/">  
            <v-img
              alt="FALM Logo"
              class="mx-auto mb-2"
              contain
              :src="require('../assets/falm.png')"
              max-width="120"
            />
          </a>
          <div>{{$t('home.falm_intro')}}</div>
        </v-card-text>
        <v-card-actions class="px-5">
          <v-btn outlined dense block color="navlink" target="_blank" href="http://www.falm.info/">
            {{$t('btntxt.learnmore')}}
          </v-btn>
        </v-card-actions>
      </v-card>

    </template>

  </ThreeColumn>

</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import StatusWidget from '../components/StatusWidget'
  import DonateIcon from '../components/icons/DonateIcon'
  import HomeTool from '../components/HomeTool'
  import HomeShortcut from '../components/HomeShortcut'
  import NewsSlide from '../components/NewsSlide'
  import api from '@/scripts/api'
  import datehelper from '@/scripts/datehelper'
  import Header from '../components/applayout/Header'
  import Tour from '@/components/Tour'
    export default {
    name: 'Home',
    components:{
      ThreeColumn,
      StatusWidget,
      DonateIcon,
      HomeTool,
      HomeShortcut,
      NewsSlide,
      Header,
      Tour
    },
    data: () => ({
      files: [],  //for latest judgement
      isLoading: false,
      isSelecting: false,  // selecting from suggestions in the main search bar
      items: [],
      search: null,
      loading: true, // datatable
      length: 4, //for news
      window: 0,  //for news
      court: 'hkcfi, hkca, hkcfa',
      courts: ['hkcfi', 'hkca', 'hkcfa', 'hkcfi, hkca, hkcfa'],
      dbcount: 53, //for stat
      totalFile: null, //for stat
      time: null, //for stat
      viewtour: false,
      showTourAlert: true,  // for tour box
      shortcutPanel: null, // for shortcut
    }),
    methods:{
      setCourt(court){
        this.court = court
      },
      format_suggestion(res){
        return res.map(r => {
          return {
            text: r,
            value: r
          }
        })
      },
      async get_latest(){  //generate list of recent judgements
        this.loading = true
        try {
          const res = await api.get_latest(this.court)
          // metadata
          this.time = res['metadata']['timestamp']
          this.dbcount = res['metadata']['db_count']
          this.totalFile = res['metadata']['files_count']
          
          // files
          this.files = res['judgments'].map(file => {
            var jud = Object()
            jud['date'] = datehelper.display_date(file['date'])
            jud['db_name'] = file['db']
            jud['neutral'] = file['neutral']
            jud['title'] = file['cases'].map(c => c.title).join('<br/>')
            jud['acts'] = file['cases'].map(c => c.act).join('<br/>')
            jud['m_acts'] = file['cases'].map(c => c.act).join('; ')
            jud['path'] = file['path']
            return jud;
          })
        } catch(err){
          console.error(err)
        } finally {
          this.loading = false
        }
      },
      async get_suggestions(){
        const res = await api.autocomplete(null, this.search)
        this.items = this.format_suggestion(res)
      },
      go_search(){
        if(this.search){
          this.$router.push({name:'search-results', query:{q: this.search}})
        }
      },
      banner_nextslide () { //for news
        this.window = this.window + 1 === this.length ? 0 : this.window + 1
      },
      banner_prevslide () { //for news
        this.window = this.window - 1 < 0 ? this.length - 1 : this.window - 1
      },
      goFile(item, event){ //for latest data table
        var selectedText = getSelection().toString()
        if (selectedText.length == 0 && event.target.tagName !== "A"){
          let routeData = this.$router.resolve({path: item.path});
          if (event.ctrlKey){
            // Ctrl + click: open in new tab
            var w = window.open(routeData.href, '_blank')
            if (event.shiftKey){
              // Ctrl + Shift + click: open in new tab and focus
              w.focus()
            }
          } else if (event.shiftKey){
            // Shift + click: open in new tab
            window.open(routeData.href)
          } else {
            this.$router.push({path: item.path})
          }
        }
      },
    },
    computed:{
      pdlang(){
        return ['tc', 'sc'].includes(this.$i18n.locale) ? 'tc' : 'en'
      },
      headers () {  //returns headers for latest judgements
        return [
          {
            text: this.$t('tbhead.case_db'),
            align: 'start',
            sortable: true,
            value: 'db_name',
            width: '15%'
          },
          {
            text: this.$t('tbhead.case_title'),
            align: 'start',
            sortable: true,
            value: 'title',
            width: '33%'
          },
          {
            text: this.$t('database.wdg_jdg_neutral'),
            align: 'start',
            sortable: true,
            value: 'neutral',
            width: '21%'
          },
          {
            text: this.$t('database.action'),
            align: 'start',
            sortable: true,
            value: 'acts',
            width: '18%'
          },
          {
            text: this.$t('database.date'),
            align: 'start',
            sortable: true,
            value: 'date',
            width: '13%'
          },
        ]
      },
      stat_wdgt(){
        return [
          {label:this.$i18n.t('database.wdg_status_updatetime'),val: datehelper.display_date(this.time)},
          {label:this.$i18n.t('database.wdg_status_judcount'),val: this.totalFile}
        ]
      },
    },
    watch:{
      search:function () {
        if(this.search){
          this.get_suggestions()
        }
      },
      court:function () {
        this.get_latest()
      },
      shortcutPanel: function(nv) {
        if (nv == null) {
          localStorage.removeItem('openshortcut')
        } else {
          localStorage.setItem('openshortcut', 'true')
        }
      }
    },
    beforeMount(){
      this.shortcutPanel = localStorage.getItem('openshortcut') ? 0 : null
    },  
    mounted(){
      this.get_latest()
    },
    metaInfo(){
      return{
        title: this.$i18n.t('home.fullname'),
        meta: [
          {
            name: 'description',
            content: 'HKLII provides free access to Hong Kong legal information, including judgments and legislations.',
          }
        ],
      }
    },
  }
</script>


<style scoped lang="scss">
@import '@/sass/_typography.scss';

/*Banner*/
  .w-100{
    padding-left: 2%;
    padding-right: 5%;
    margin-right: 0px;
  }
  .w-50{
      width: 50%;
      margin: 0 auto !important;
  }

  .sitetitle{
    font-family: $display-font;
    font-size: 2.8rem;
    line-height: 3rem;
  }
  .sitetitle-xs{ /*for mobile*/
    font-size: 2.15rem;
    line-height: 2.4rem;
  }

  .siteslogan{
    font-family: $display-font;
    font-weight: 500;
    font-style: italic;
    font-size: 1.7rem;
    line-height: 2rem;
  }
  .siteslogan-xs{ /*for mobile*/
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
    
  .logoimage{
    background-position: left center !important;
  }

  div .bannersearch{
    background-color:  rgba(209, 194, 194, 0.6) !important;
    border-radius: 0px;
    padding: 10px;
  }
  .hero-bg{
    width:100% ;
  }
  .sponsor-banner-bg{
    background-image: url(../assets/sponsors23/sponsor_header.png);
    background-position: top center;
    border-bottom: 2px solid var(--v-primary-base) !important;
    margin-bottom: 0px;
  }

  /*news*/
  .news{
    max-width: 850px;
    a {
      @include link-no-underline;
    }
  }
  .news-active{
    background-color: var(--v-liiblack-base) !important;
  }
  .news-title{
    word-break: normal;
    line-height: 1.4em !important;
  }

  /*latest judgment*/
  .tlatest ::v-deep tr{
    cursor: pointer;
  }
  .tlatest ::v-deep thead{
    background: var(--v-lsidebg-base);
  }
  .dtdesktop table{ /*datatable width not honored fix*/
    table-layout : fixed;
  }
  .tlatest ::v-deep td {
    padding-top: 5px !important;
    padding-bottom: 3px !important;
    padding-right: 2px !important;
    vertical-align: top;
  }
  .tlatest {
    border-bottom: 1px solid var(--v-darkgrey-lighten3) ;
  }

  .mobiledt_label{
    background-color: var(--v-l_case-base);
    color: var(--v-liiblack-base);
    padding-left:8px;
    padding-right:8px;
    border-radius: 20px;
    box-decoration-break: clone;
  }

  .dt-date{
    /*font-size: 0.8rem !important;*/
    letter-spacing: -0.15pt !important;
  }

  /*dropdown overwrite*/
  .theme--light.v-list{
    background: white;
  }

  .app-hklii.v-application .primary--text  /*overwrite the active class color set in app.vue, for mobile nav*/
  {
    color: var(--v-primary-base) !important;
  }

  /*.theme--light.v-text-field--outlined {
    color: rgba(173, 36, 39, 0.5) !important;
  }*/

  /*tour alert*/
  a.alert-link{
    @include link-underlined( var(--v-link-lighten2),  var(--v-link-base));
    font-weight: 600;
    font-size: 13pt;
  }

  /*shortcuts for frequent users*/
  #home-shortcut hr{
    border-top: 1px solid var(--v-liiblack-lighten2);
  }
  #home-shortcut ::v-deep .v-expansion-panel-content__wrap{ 
    padding: 0px 0px; /*remove padding */
  }
  #home-shortcut ::v-deep .v-expansion-panel--active > .v-expansion-panel-header{
    min-height: 20px;
  }
  #home-shortcut ::v-deep .v-icon{
    color: var(--v-liiblack-lighten4);
  }

</style>